import { csrfHeaders } from '../../core/csrf.js';

// The document format is selected by Accept, while the endpoint owns the actual generation.
document.addEventListener('DOMContentLoaded', () => {
	var root = document.querySelector('.ui-deliverables');
	if (!root) { return; }

	var status = root.querySelector('.js-deliverable-status');
	var endpoint = root.getAttribute('data-endpoint');
	var slug = root.getAttribute('data-slug');
	var buttons = Array.prototype.slice.call(root.querySelectorAll('button[data-media-type]'));

	function setBusy(busy, message) {
		buttons.forEach(function (b) { b.disabled = busy; });
		status.textContent = message || '';
	}

	function download(blob, filename) {
		var url = URL.createObjectURL(blob);
		var a = document.createElement('a');
		a.href = url;
		a.download = filename;
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
		URL.revokeObjectURL(url);
	}

	buttons.forEach(function (button) {
		button.addEventListener('click', function () {
			var mediaType = button.getAttribute('data-media-type');
			var extension = button.getAttribute('data-extension');
			var headers = { 'Accept': mediaType };

			setBusy(true, root.getAttribute('data-busy-label'));

			fetch(endpoint, { method: 'POST', headers: csrfHeaders(endpoint, headers), credentials: 'same-origin' })
				.then(function (response) {
					if (response.status === 202) {
						// Past twenty-five seconds the render became a treatment: there is no body to download on
						// THIS response, and `response.ok` is true for a 202 — reading it as a blob handed the
						// person an empty file. Location names the monitor that will hold the document.
						var monitor = response.headers.get('Location');
						setBusy(false, root.getAttribute('data-handed-over-label'));
						if (monitor) { window.location.href = monitor; }
						return;
					}
					if (response.ok) {
						return response.blob().then(function (blob) {
							download(blob, slug + '.' + extension);
							setBusy(false, '');
						});
					}
					// Error responses expose their message for the person requesting the document.
					return response.text().then(function (body) {
						var message = body;
						try { message = (JSON.parse(body).message) || body; } catch (e) { /* Non-JSON response. */ }
						setBusy(false, message);
					});
				})
				.catch(function (e) { setBusy(false, String(e)); });
		});
	});
});
